import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/categories";
import SearchBox from "@/components/feature/SearchBox";

const linkBase =
  "relative font-label text-sm tracking-wide uppercase transition-colors whitespace-nowrap cursor-pointer";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/50 bg-background-50/85 backdrop-blur-md">
      <div className="flex h-16 w-full items-center gap-4 px-4 md:px-6 lg:px-10">
        <Link to="/" className="flex flex-shrink-0 items-center gap-2.5" onClick={() => setMobileOpen(false)}>
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-foreground-950">
            <i className="ri-movie-2-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-50">
              黄色<span className="text-primary-400">大片</span>
            </span>
            <span className="mt-0.5 hidden text-[10px] tracking-[0.2em] text-foreground-500 sm:block">
              MOVIE PORTAL
            </span>
          </span>
        </Link>

        <nav className="ml-6 hidden items-center gap-7 lg:flex">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `${linkBase} ${isActive ? "text-primary-400" : "text-foreground-300 hover:text-foreground-50"}`
            }
          >
            首页
          </NavLink>

          <div
            className="relative"
            onMouseEnter={() => setCategoryOpen(true)}
            onMouseLeave={() => setCategoryOpen(false)}
          >
            <button
              type="button"
              className={`${linkBase} flex items-center gap-1 text-foreground-300 hover:text-foreground-50`}
            >
              分类
              <i className={`ri-arrow-down-s-line text-base transition-transform ${categoryOpen ? "rotate-180" : ""}`} />
            </button>
            {categoryOpen && (
              <div className="absolute left-1/2 top-full z-50 w-[420px] -translate-x-1/2 pt-3">
                <div className="grid grid-cols-3 gap-1 rounded-lg border border-background-200/70 bg-background-100 p-3">
                  {categories.map((category) => (
                    <Link
                      key={category.key}
                      to={`/category/${category.key}`}
                      className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-300 transition-colors hover:bg-background-200/60 hover:text-foreground-50"
                    >
                      <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-100 text-primary-400">
                        <i className={`${category.icon} text-sm`} />
                      </span>
                      {category.name}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {navLinks.slice(2).map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `${linkBase} ${isActive ? "text-primary-400" : "text-foreground-300 hover:text-foreground-50"}`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-56 xl:block">
          <SearchBox />
        </div>

        <Link
          to="/special"
          className="ml-auto hidden items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 font-label text-sm tracking-wide text-foreground-950 transition-colors hover:bg-primary-400 lg:inline-flex xl:ml-3"
        >
          <i className="ri-fire-line text-base" />
          影评专题
        </Link>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMobileOpen((value) => !value)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-100 transition-colors hover:bg-background-200/60 lg:hidden"
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200/60 bg-background-50 px-4 pb-5 pt-4 lg:hidden">
          <div className="mb-4">
            <SearchBox autoFocus />
          </div>
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `border-b border-background-200/50 py-3 font-label text-base uppercase tracking-wide transition-colors ${
                    isActive ? "text-primary-400" : "text-foreground-200"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-4">
            <p className="mb-2 text-xs text-foreground-500">按类型浏览</p>
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <Link
                  key={category.key}
                  to={`/category/${category.key}`}
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-1.5 rounded-full bg-background-200/60 px-3 py-1.5 text-sm text-foreground-200 transition-colors hover:bg-primary-100 hover:text-primary-400"
                >
                  <i className={`${category.icon} text-sm`} />
                  {category.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}